import { render, staticRenderFns } from "./GlobalAudioPlayer.vue?vue&type=template&id=32e117fb&scoped=true&"
import script from "./GlobalAudioPlayer.vue?vue&type=script&lang=ts&"
export * from "./GlobalAudioPlayer.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalAudioPlayer.vue?vue&type=style&index=0&id=32e117fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e117fb",
  null
  
)

export default component.exports